
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';

function Index({dishs, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

     const [showSpecials, setShowSpecials] = useState(false);

    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div  style={{padding: '0 20px'}}>
                    <img
                         onContextMenu={(e) => e.preventDefault()}
                        src={require('./assets/top.png')}
                        style={{
                        objectFit: 'contain',
                        width: '100%',
                        height: 140, pointerEvents: 'none',
                        marginTop: -10,
                        }}
                    />

                     <img
                         onContextMenu={(e) => e.preventDefault()}
                        src={require('./assets/title.png')}
                        style={{
                        objectFit: 'contain',
                        width: '100%',
                            height: 140, pointerEvents: 'none',
                          marginTop: -10,
                      
                        }}
                    />

                    <div style={{display: 'flex', flexDirection: 'row', gap: 10, height: 500}}>
                        <div style={{width: '50%', height: 500, overflow: 'scroll',display: 'flex', flexDirection: 'column', gap: 10,  alignItems: 'center'}}>
                            <img src={require('./assets/Drinks.png')} style={{ width: 120, height: 100, objectFit: 'contain' }} />
                            <img src={require('./assets/hapy1.png')} style={{width: 220, height: 500, objectFit: 'contain'}} />
                        </div>
                        <div style={{width: '50%', height: 500, overflow: 'scroll',display: 'flex', flexDirection: 'column', gap: 10,  alignItems: 'center', justifyContent: 'flex-start'}}>
                            <img src={require('./assets/PeruvianBites.png')} style={{ width: 200, height: 100, objectFit: 'contain' }} />
                            <img src={require('./assets/hapy2.png')} style={{width: 220, height: 200, objectFit: 'contain'}} />
                        </div>
                    </div>
                </div>
                
                 {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
            </LayoutContent>
        </div>
    );
}
export default Index;